import {Injectable} from '@angular/core';
import {BaseRequestOptions, Http, Response, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Rx';

import {Inscription} from './inscription.model';

@Injectable()
export class EnscolService {

    private resourceStatutUrl = 'api/enscolStatut';
    private resourceInscriptionsUrl = 'api/enscolInscriptions';

    constructor(private http: Http) {
    }

    private buildSearchParams(pers_id: any): URLSearchParams {
        let params = new URLSearchParams();
        params.set('pers_id', pers_id);
        return params;
    }

    getInscriptions(pers_id: any): Observable<Inscription[]> {
        return this.http.get(this.resourceInscriptionsUrl, {search: this.buildSearchParams(pers_id)})
            .map((res: any) => <Inscription[]>res.json());
    }

    getStatut(pers_id: any): Observable<string> {
        return this.http.get(this.resourceStatutUrl, {search: this.buildSearchParams(pers_id)}).map((res: any) => res._body);
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/enscol/enscol.service.ts